module.exports = __webpack_public_path__ + "img/img53.7b85cfd7.svg";